<template>
    <footer>
        <div class="audio-btn" v-if="hasAudio">
            <a href="#" class="play" @click.prevent.stop="mute"><i :class="muted ? 'icono-volumeMedium' : 'icono-volumeMute'"></i></a>
        </div>

        <a href="#" @click.prevent.stop="openSlidePanel" v-if="this.details">
            <ul>
                <li class="foot1">{{footer.artist}}</li>
                <li class="foot2">{{footer.title}}</li>
                <li class="foot3">{{footer.summary}}</li>
            </ul>
        </a>
        <ul v-else>
            <li class="foot1">{{footer.artist}}</li>
            <li class="foot2">{{footer.title}}</li>
            <li class="foot3" v-html="footer.summary"></li>
        </ul>
    </footer>
</template>

<script>
export default {
    props: ['footer', 'details', 'hasAudio'],
    data() {
        return {
            muted: false
        }
    },
    methods: {
        openSlidePanel() {
            this.$root.$emit('openSlidePanel', this.details)
        },
        mute() {
            this.muted = !this.muted
            this.$emit('mute')
        }
    }
}
</script>